// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"7c2ebf3af334090d765b","147":"638329e333935c64c9a3","251":"165f3bfe6e4a6e1a415b","352":"899d504dff3bc7dd1b82","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};